import { DisplayInputValue } from '@reapitform/dashboard-ui'
import { LoadingSkeleton } from '@reapitform/common-ui'
import React, { FC } from 'react'
import { FlexContainer } from '@reapit/elements'

const BusinessDetailsDisplayViewLoading: FC = () => {
  return (
    <FlexContainer isFlexColumn>
      <DisplayInputValue title="Business Name">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Trading Name">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="ABN">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="ACN">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Logo">
        <LoadingSkeleton height="3.875rem" />
      </DisplayInputValue>
    </FlexContainer>
  )
}

export default BusinessDetailsDisplayViewLoading
